<template>
    <div>
        <loader :show="enviando"/>
        <v-card>
            <v-toolbar>
                <v-btn icon class="hidden-xs-only" @click="$router.go(-1)">
                <v-icon>arrow_back</v-icon>
                </v-btn>

                <v-toolbar-title>Expediente de personal</v-toolbar-title>

                    <v-spacer></v-spacer> 
            </v-toolbar>
            <v-container  fluid grid-list-md>
                <v-layout row wrap>
                    <v-flex xs12 sm5 md4>
                        <v-card >
                            <v-img
                                class="white--text"
                                height="200px"
                                src="/img/no-user-image.gif"
                            />
                            <v-card-title>
                                <v-toolbar flat height="50px" color="white">
                                    <v-toolbar-title>Personal</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-menu v-if="puedeModificarPersonal"
                                        transition="scale-transition"
                                        origin="right top"
                                        bottom
                                        left
                                        
                                    >
                                        <v-btn class="ma-0" icon slot="activator">
                                            <v-icon>more_vert</v-icon>
                                        </v-btn>
                                        <v-list class="app-card-action">
                                            <v-list-tile @click="modificaPersonalDialog=true">
                                                <i class="fa fa-user-edit blue--text mr-2 fs-14"></i>
                                                <span>Modificar datos</span>
                                            </v-list-tile>
                                        </v-list>
                                    </v-menu>
                                </v-toolbar>
                            <div>
                                <span><b>Código: </b></span> <span>{{expediente.codigo}}</span><br>
                                <span><b>Nombre: </b></span> <span>{{expediente.nombre}}</span><br>
                                <span><b>Paterno: </b></span> <span>{{expediente.paterno}}</span><br>
                                <span><b>Materno: </b></span> <span>{{expediente.materno}}</span><br>
                                <span><b>Correo: </b></span> <span>{{expediente.correo}}</span><br>
                                <span><b>Celular: </b></span> <span>{{expediente.celular}}</span><br>
                                <span><b>Teléfono: </b></span> <span>{{expediente.telefono}}</span><br>
                                <span><b>CURP: </b></span> <span>{{expediente.curp}}</span><br>
                                <span><b>RFC: </b></span> <span>{{expediente.rfc}}</span><br>
                                <span><b>Status: </b></span> <span v-if="expediente.status">{{expediente.status}}</span> <span v-else>SIN ASIGNAR</span>
                              
                                <v-btn v-if="expediente.status && expediente.status=='ACTIVO'" small  color="error"  @click="activar(expediente._id)">Desactivar</v-btn>
                                <v-btn v-else color="success" small @click="activar(expediente._id)">Activar</v-btn>
                            </div>
                            </v-card-title>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 sm7 md8>
                    <v-card>
                        <v-card-text>
                            <v-toolbar flat height="50px" color="white">
                                <v-toolbar-title>Domicilio</v-toolbar-title>
                                <v-spacer></v-spacer>                            
                                <v-menu v-if="puedeModificarDomicilio"
                                    transition="scale-transition"
                                    origin="right top"
                                    bottom
                                    left 
                                >
                                    <v-btn class="ma-0" icon slot="activator">
                                        <v-icon>more_vert</v-icon>
                                    </v-btn>
                                    <v-list class="app-card-action">
                                        <v-list-tile @click="modificaDomicilioDialog=true">
                                            <i class="fa fa-user-edit blue--text mr-2 fs-14"></i>
                                            <span>Modificar datos</span>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </v-toolbar>
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md6>
                                    <span><b>Calle: </b>{{expediente.domicilio.calle}}</span><br>
                                </v-flex>
                                <v-flex xs6 sm6 md3>
                                    <span><b>Núm. ext.: </b>{{expediente.domicilio.numeroExterior}}</span>
                                </v-flex>
                                <v-flex xs6 sm6 md3>
                                    <span><b>Núm. int.: </b>{{expediente.domicilio.numeroInterior}}</span>
                                </v-flex>
                                <v-flex xs12 sm12 md4>
                                    <span><b>Municipio: </b>{{expediente.domicilio.municipio}}</span>
                                </v-flex>
                                <v-flex xs12 sm12 md4>
                                    <span><b>Estado: </b>{{expediente.domicilio.estado}}</span>
                                </v-flex>
                                <v-flex xs12 sm12 md4>
                                    <span><b>Colonia: </b>{{expediente.domicilio.colonia}}</span>
                                </v-flex>
                                <v-flex xs12 sm12 md4>
                                    <span><b>CP: </b>{{expediente.domicilio.codigoPostal}}</span>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-text>
                            <v-toolbar flat height="50px" color="white">
                                <v-toolbar-title>Laboral</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-menu
                                    v-if="puedeModificarLaboral"
                                    transition="scale-transition"
                                    origin="right top"
                                    bottom
                                    left
                                    
                                >
                                    <v-btn class="ma-0" icon slot="activator">
                                        <v-icon>more_vert</v-icon>
                                    </v-btn>
                                    <v-list class="app-card-action">
                                        <v-list-tile @click="modificaLaboralDialog=true" >
                                            <i class="fa fa-user-edit blue--text mr-2 fs-14"></i>
                                            <span>Modificar datos</span>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </v-toolbar>
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md6>
                                    <span><b>Puesto: </b>{{expediente.laboral.puesto}}</span><br>
                                </v-flex>
                                <v-flex xs12 sm12 md6>
                                    <span><b>Dependencia: </b>{{expediente.laboral.dependencia}}</span>
                                </v-flex>
                                <v-flex xs12 sm12 md6>
                                    <span><b>Correo oficial: </b>{{expediente.laboral.correoOficial}}</span>
                                </v-flex>
                                <v-flex xs12 sm12 md6>
                                    <span><b>Teléfono: </b>{{expediente.laboral.telefono}}</span>
                                </v-flex>
                                <v-flex xs12 sm12 md6>
                                    <span><b>Ubicación: </b>{{expediente.laboral.ubicacion}}</span>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-text>
                            <v-toolbar flat height="50px" color="white">
                                <v-toolbar-title>Sueldo</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <!-- <v-btn small icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn> -->
                            </v-toolbar>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md4>
                                    <span><b>Diario: </b>{{getSueldoActual.diario}}</span><br>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <span><b>Mensual bruto: </b>{{getSueldoActual.mensualBruto}}</span>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-text>
                            <v-toolbar flat height="50px" color="white">
                                <v-toolbar-title>Horario</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-menu v-if="puedeAsignarHorario"
                                    transition="scale-transition"
                                    origin="right top"
                                    bottom
                                    left
                                    
                                >
                                    <v-btn class="ma-0" icon slot="activator">
                                        <v-icon>more_vert</v-icon>
                                    </v-btn>
                                    <v-list class="app-card-action">
                                        <v-list-tile @click="asigHorario=true">
                                            <i class="fa fa-calendar-alt blue--text mr-2 fs-14"></i>
                                            <span>Asignar horario</span>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </v-toolbar>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md4>
                                    <span v-if="!expediente.horario._id"><i>No asignado</i></span>
                                    <span v-else>{{expediente.horario.nombre}}</span>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex xs12 sm12 md6>
                        <!-- HISTORICOS DE PUESTOS -->
                        <his-puestos 
                            :puestos="expediente.historialPuestos"
                            @puestoAgregado="puestoAgregado"
                            @puestoActual="puestoActual"
                            @puestoModificado="puestoModificado"
                            @enviandoStart="enviando=true"
                            @enviandoStop="enviando=false"
                        />
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                        <!-- HISTORICOS DE DEPENDENCIAS -->
                        <his-dependencias 
                            :dependencias="expediente.historialDependencias"
                            @dependenciaAgregada="dependenciaAgregada"
                            @dependenciaActual="dependenciaActual"
                            @dependenciaModificada="dependenciaModificada"
                            @enviandoStart="enviando=true"
                            @enviandoStop="enviando=false"
                        />
                    </v-flex>

                    <v-flex xs12 sm12 md12>
                        <!-- HISTORICOS DE SUELDOS -->
                        <his-sueldos 
                            :sueldos="expediente.historialSueldos"
                            @sueldoAgregado="sueldoAgregado"
                            @sueldoActual="sueldoActual"
                            @sueldoModificado="sueldoModificado"
                            @enviandoStart="enviando=true"
                            @enviandoStop="enviando=false"
                        />
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card>

        <modifica-personal 
            v-if="modificaPersonalDialog"
            :dialog="modificaPersonalDialog"
            :id="id"
            :codigo="expediente.codigo"
            :paterno="expediente.paterno"
            :materno="expediente.materno"
            :nombre="expediente.nombre"
            :curp="expediente.curp"
            :rfc="expediente.rfc"
            :correo="expediente.correo"
            :celular="expediente.celular"
            :telefono="expediente.telefono"
            @cerrar="modificaPersonalDialog=false"
            @enviandoStart="enviando=true"
            @enviandoStop="enviando=false"
            @personalModificado="personalModificado"
        />
        <modifica-domicilio 
            v-if="modificaDomicilioDialog"
            :dialog="modificaDomicilioDialog"
            :id="id"
            :domicilio="expediente.domicilio"
            @cerrar="modificaDomicilioDialog=false"
            @enviandoStart="enviando=true"
            @enviandoStop="enviando=false"
            @domicilioModificado="domicilioModificado"
        />
        <modifica-laboral 
            v-if="modificaLaboralDialog"
            :dialog="modificaLaboralDialog"
            :id="id"
            :laboral="expediente.laboral"
            @cerrar="modificaLaboralDialog=false"
            @enviandoStart="enviando=true"
            @enviandoStop="enviando=false"
            @laboralModificado="laboralModificado"
        />

        <asignar-horario 
            v-if="asigHorario"
            :mostrar="asigHorario"
            :horario="expediente.horario"
            :usuario="id"
            @cancelarAsigHorario="asigHorario=false"
            @horarioAsignado="horarioAsignado"
            @enviandoStart="enviando=true"
            @enviandoStop="enviando=false"
        />
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from '../../components/Loader'
import ModificaPersonal from './modificaPersonal'
import ModificaDomicilio from './modificaDomicilio'
import ModificaLaboral from './modificaLaboral'
import AsignarHorario from './asignarHorario'

import HisPuestos from './hisPuestos'
import HisDependencias from './hisDependencias'
import HisSueldos from './hisSueldos'
import axios from 'axios'
import numeral from 'numeral'

export default {
    name: 'ExpedientePersonal',
	components: {
        Loader,
        ModificaPersonal,
        ModificaDomicilio,
        ModificaLaboral,
        HisPuestos,
        HisDependencias,
        HisSueldos,
        AsignarHorario
	},
    
    computed: {
        ...mapGetters([
            "sessionToken",
            "httpURL",
            "userId",
            "permisos",
            "role"
        ]),
        
        puedeModificarPersonal(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 164) >= 0 
        },
        puedeModificarDomicilio(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 165) >= 0 
        },
        puedeModificarLaboral(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 166) >= 0 
        },
        puedeAsignarPuesto(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 175) >= 0 
        },
        puedeAsignarDependencia(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 168) >= 0 
        },
        puedeAsignarHorario(){
            return this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 183) >= 0 
        },
        getSueldoActual(){
            let sueldo = {
                diarioBruto: 'No especificado',
                neto: 'No especificado',
                bruto: 'No especificado'
            };
            let index = this.expediente.historialSueldos.findIndex(x=>x.actual === true);
            if( index >= 0 ){
                sueldo.diarioBruto = numeral(this.expediente.historialSueldos[index].diarioBruto).format('$0,0.00');
                sueldo.neto = numeral(this.expediente.historialSueldos[index].neto).format('$0,0.00');
                sueldo.bruto = numeral(this.expediente.historialSueldos[index].bruto).format('$0,0.00');
            }
            return sueldo;
            
        }
    },
    data() {
        return {
            id: this.$route.params.id,
            modificaPersonalDialog: false,
            modificaDomicilioDialog: false,
            modificaLaboralDialog: false,
            enviando:false,
            expediente: {
                domicilio: {},
                laboral:{},
                salario:{},
                historialPuestos:[],
                historialDependencias:[],
                historialSueldos:[],
                horario:{}
            },
            asigHorario:false
        }
    },
    created(){
        axios.get(this.httpURL+'/personal/expediente/'+this.id,{headers:{token: this.sessionToken}})
            .then(res => {
                // console.log(res);
                // let personal = [];
                // console.log(res.data.expediente);
                this.expediente = res.data.expediente;
                if(!this.expediente.horario)
                    this.expediente.horario = {};
                this.enviando = false;
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
                // console.log(error);
                this.enviando = false;
                this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
            });
    },
   
    methods:{
          activar(id){
            this.enviando=true;
            axios.put(this.httpURL+'/personal/status/'+id,
                {},
                {headers:{token: this.sessionToken}
            })
            .then(res => {
                this.expediente.status = res.data.status;
                this.enviando = false;
                this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
            })
            .catch(error => {
            // console.log(error);
            this.enviando = false;
            this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
        });

        },
        personalModificado(personal){
            // console.log(personal);
            this.expediente.nombre = personal.nombre;
            this.expediente.paterno = personal.paterno;
            this.expediente.materno = personal.materno;
            this.expediente.correo = personal.correo;
            this.expediente.celular = personal.celular;
            this.expediente.telefono = personal.telefono;
            this.expediente.curp = personal.curp;
            this.expediente.rfc = personal.rfc;
        },
        domicilioModificado(domicilio){
            // console.log(domicilio);
            this.expediente.domicilio = domicilio;
        },
        laboralModificado(laboral){
            // console.log(laboral);
            this.expediente.laboral = laboral;
        },
        puestoAgregado(puesto){
            this.expediente.historialPuestos.unshift(puesto);
        },
        puestoActual(id,puesto){
            this.expediente.historialPuestos.forEach(element => {
                element.actual = element._id == id ? true : false;
            });
            this.expediente.laboral.puesto = puesto;
        },
        puestoModificado(puesto){
            let index = this.expediente.historialPuestos.findIndex(x=>x._id == puesto._id);
            this.expediente.historialPuestos[index] = puesto;
        },
        dependenciaAgregada(dependencia){
            this.expediente.historialDependencias.unshift(dependencia);
        },
        dependenciaActual(id,dependencia){
            this.expediente.historialDependencias.forEach(element => {
                element.actual = element._id == id ? true : false;
            });
            this.expediente.laboral.dependencia = dependencia;
        },
        dependenciaModificada(dependencia){
            let index = this.expediente.historialDependencias.findIndex(x=>x._id == dependencia._id);
            this.expediente.historialDependencias[index] = dependencia;
        },
        sueldoAgregado(sueldo){
            this.expediente.historialSueldos.unshift(sueldo);
        },
        sueldoActual(id){
            // console.log(id);
            this.expediente.historialSueldos.forEach(element => {
                element.actual = element._id == id ? true : false;
            });
        },
        sueldoModificado(sueldo){
            let index = this.expediente.historialSueldos.findIndex(x=>x._id == sueldo._id);
            this.expediente.historialSueldos[index] = sueldo;
        },
        horarioAsignado(horario){
            this.expediente.horario._id = horario._id;
            this.expediente.horario.nombre = horario.nombre;
        }
    }
}
</script>